export default __webpack_public_path__ + "static/media/floor.b86a376a.jpg";